// src/components/PreferenciasModal.js
import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { FaBars, FaWindowMaximize, FaTimes } from "react-icons/fa";

export default function PreferenciasModal({ onClose }) {
  const { menuPosition, setMenuPosition } = useContext(AuthContext);

  return (
    <div
      className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm flex items-center justify-center z-[60] p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-bold text-gray-800">Preferencias</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
            aria-label="Cerrar"
          >
            <FaTimes />
          </button>
        </div>

        <p className="text-sm text-gray-500 mb-4">
          Elige cómo quieres ver el menú de navegación.
        </p>

        <div className="grid grid-cols-2 gap-4">
          <button
            onClick={() => setMenuPosition("lateral")}
            className={`border rounded-xl p-4 flex flex-col items-center gap-2 transition ${
              menuPosition === "lateral"
                ? "border-indigo-500 ring-2 ring-indigo-100 bg-indigo-50"
                : "border-slate-200 hover:border-indigo-300"
            }`}
          >
            <FaBars className="text-2xl text-indigo-600" />
            <span className="font-medium text-slate-700">Menú lateral</span>
          </button>

          <button
            onClick={() => setMenuPosition("superior")}
            className={`border rounded-xl p-4 flex flex-col items-center gap-2 transition ${
              menuPosition === "superior"
                ? "border-indigo-500 ring-2 ring-indigo-100 bg-indigo-50"
                : "border-slate-200 hover:border-indigo-300"
            }`}
          >
            <FaWindowMaximize className="text-2xl text-indigo-600" />
            <span className="font-medium text-slate-700">Menú superior</span>
          </button>
        </div>

        <button
          onClick={onClose}
          className="mt-6 w-full bg-indigo-600 hover:bg-indigo-700 text-white py-2 rounded-lg font-semibold transition"
        >
          Listo
        </button>
      </div>
    </div>
  );
}
